function getStickyHeaderOffset() {
  // Try common theme patterns first
  const header = document.querySelector('#header-component, .header, header, .shopify-section-header');
  if (!header) return 0;

  // If header is sticky/fixed, use its height
  const styles = window.getComputedStyle(header);
  const isSticky = styles.position === 'sticky' || styles.position === 'fixed';

  return isSticky ? header.getBoundingClientRect().height : 0;
}

function scrollToElementWithOffset(el, extraOffset =35) {
  const headerOffset = getStickyHeaderOffset() + extraOffset;
  const y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;

  window.scrollTo({ top: y, behavior: 'smooth' });
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-hero-scroll-down]');
  if (!btn) return;

  const hero = btn.closest('[data-hero]');
  if (!hero) return;

  const next = hero.closest('.shopify-section')?.nextElementSibling;
  if (!next) return;

  scrollToElementWithOffset(next);
});